import { createReducer, on } from '@ngrx/store';

// Prettier 1.18.2 cannot parse `import type`, and the pre-commit hook runs it,
// so the type rides along on a plain import. TypeScript elides it.
import { QueueItem } from 'capacitor-clogi-uploader';

import * as actions from './upload-queue.actions';

export interface State {
  items: QueueItem[];
}

export const initialState: State = { items: [] };

export const uploadQueueReducer = createReducer(
  initialState,

  on(actions.uploadQueueSynced, (state, { items }) => ({ ...state, items })),

  on(actions.uploadProgressed, (state, { id, bytesSent, bytesTotal }) => ({
    ...state,
    items: state.items.map(item =>
      item.id === id ? { ...item, bytesSent, bytesTotal } : item
    ),
  })),

  on(actions.uploadStateChanged, (state, { id, state: next, error }) => {
    // A done item is gone from the native queue too -- drop it rather than
    // waiting for the next sync, so the pending thumbnail does not linger
    // after the real one has arrived.
    if (next === 'done') {
      return { ...state, items: state.items.filter(item => item.id !== id) };
    }
    return {
      ...state,
      items: state.items.map(item =>
        item.id === id ? { ...item, state: next, lastError: error } : item
      ),
    };
  })
);
